module.exports = __webpack_public_path__ + "img/69.214815f7.jpg";